import React from 'react';
import { connect } from 'react-redux';
import _ from 'lodash';
import { appContext } from '../../util/decorators';
import blogConfig from '../../config/blogConfig.json';
import podcastConfig from '../../config/podcastConfig.json';

const mapStateToProps = state => ({
  siteBlogs: blogConfig[state.country],
  sitePodcasts: podcastConfig[state.country],
});

@connect(mapStateToProps)
@appContext
export default class FeedText extends React.PureComponent {

  render() {
    const { contentContainer, siteBlogs, sitePodcasts, titlePrefix } = this.props;

    const blogId = _.get(contentContainer, 'tags.blogs[0]');
    const podcastId = _.get(contentContainer, 'tags.podcasts[0]');
    let siteMediaItem = '';

    if (blogId) {
      siteMediaItem = siteBlogs;
    } else if (podcastId) {
      siteMediaItem = sitePodcasts;
    }

    const mediaItem = (blogId || podcastId) ?
      _.chain(siteMediaItem)
        .filter(item => (item.id === blogId || item.id === podcastId))
        .map(item => ({
          name: item.name,
          image: require(`../../../assets/media-images/${item.images.round}`),
        }))
        .first()
        .value()
      : null;

    return (
      <div>
        { titlePrefix }
        { mediaItem && <span className="media-item-name">{ mediaItem.name }: </span> }
        { contentContainer.newsFeedTitle || contentContainer.title }
      </div>
    );
  }
}

FeedText.propTypes = {
  contentContainer: React.PropTypes.object,
  siteBlogs: React.PropTypes.object,
  sitePodcasts: React.PropTypes.object,
  titlePrefix: React.PropTypes.string,
};



// WEBPACK FOOTER //
// ./src/component/NewsFeed/FeedText.jsx